<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>ออเดอร์เดือนนี้ (บุชเชอรี่)</el-breadcrumb-item>
    </el-breadcrumb>
    <v-layout row wrap class="mb-2 mx-0">
      <v-flex xs12 sm9 md9>
        <!-- <el-card class="box-card">
          <v-text-field
            v-model="search"
            placeholder="ค้นหาออเดอร์ : พิมพ์หมายเลขออเดอร์, ชื่อผู้สั่ง, เบอร์โทร"
            dense
            outlined
            @keydown.enter.prevent="loadOrder"
            clearable
          ></v-text-field>
        </el-card> -->
        <!-- <el-card class="box-card">
          <v-layout wrap>
            <v-flex class="text-xs-center">
              <strong>ยอดขาย</strong>
              <br />
              <h4 class="mt-2">฿ {{ amount.revenue | numFormat("0,0.00") }}</h4>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าสินค้า</strong>
              <br />
              <h4 class="mt-2">
                ฿
                {{
                  (parseFloat(amount.food) + parseFloat(amount.vat))
                    | numFormat("0,0.00")
                }}
              </h4>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าจัดส่ง</strong>
              <br />
              <h4 class="mt-2">
                ฿
                {{
                  (amount.delivery + amount.delivery_tax) | numFormat("0,0.00")
                }}
              </h4>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ส่วนลด</strong>
              <br />
              <h4 class="mt-2">
                ฿ {{ amount.discount | numFormat("0,0.00") }}
              </h4>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>จำนวนบิล</strong>
              <br />
              <h4 class="mt-2">
                {{
                  ((amount.completed / orderList.length) * 100)
                    | numFormat("0,0")
                }}%
                <span>({{ amount.completed }}/{{ orderList.length }})</span>
              </h4>
            </v-flex>
          </v-layout>
        </el-card> -->
      </v-flex>
      <v-flex xs12 sm3 md3 class="text-xs-right"> </v-flex>
    </v-layout>

    <v-tabs v-model="activeTab" slider-color="primary" flat class="pt-3">
      <!-- <v-tab @click="handleTabChanged('all')">ทั้งหมด</v-tab> -->
      <v-tab @click="handleTabChanged('pending')">ยังไม่ชำระเงิน</v-tab>
      <v-tab @click="handleTabChanged('processing')"
        >ชำระเงินแล้ว (ADMIN)</v-tab
      >
      <v-tab @click="handleTabChanged('cooking')"
        >กำลังแพ็คสินค้า (Warehouse)</v-tab
      >
      <v-tab @click="handleTabChanged('ready-to-go')"
        >รอจัดส่ง (Warehouse)</v-tab
      >
      <v-tab @click="handleTabChanged('delivering')"
        >จัดส่งแล้ว (Warehouse)</v-tab
      >
      <v-tab @click="handleTabChanged('completed')"
        >เรียบร้อยแล้ว (ADMIN)</v-tab
      >
    </v-tabs>
    <el-card class="mt-0">
      <v-data-table
        :headers="headers"
        :items="orderList"
        :loading="isLoading"
        :page.sync="options.page"
        :options.sync="options"
        :server-items-length="totalItems"
        @update:options="updatePagination"
        class="elevation-0"
        :height="height"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../../assets/img/no-order.png" style="width: 80px" />
          </div>
        </template>

        <template v-slot:item.order_type="{ item }">
          <div style="min-height: 60px; width: 140px">
            <div class="pt-3">
              <el-tooltip
                content="เดลิเวอรี่"
                placement="top"
                v-if="item.order_type == 'delivery'"
              >
                <i class="fas fa-motorcycle mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="คอมเมิร์ซ"
                placement="top"
                v-if="item.order_type == 'commerce'"
              >
                <i class="fas fa-shopping-bag mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="รับเองที่ร้าน"
                placement="top"
                v-if="item.order_type == 'pickup'"
              >
                <i class="fas fa-store mr-2"></i>
              </el-tooltip>

              <span class="grey--text">{{ item.order_reference }}-</span>
              {{ item.order_id | numFormat("00000") }}
            </div>

            <div
              v-if="item.status == 'cancelled'"
              class="grey lighten-2 badge-status"
            >
              ยกเลิกแล้ว
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>
            <div v-else-if="item.status == 'new'" class="red badge-status">
              มาใหม่
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="amber darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'processing'"
              class="blue darken-2 badge-status"
            >
              ชำระเงินแล้ว
            </div>
            <div
              v-if="item.status == 'cooking'"
              class="blue darken-4 badge-status"
            >
              กำลังแพ็คสินค้า
            </div>
            <div
              v-if="item.status == 'ready-to-go'"
              class="pink lighten-3 badge-status"
            >
              รอจัดส่ง
            </div>
            <div
              v-if="item.status == 'delivering'"
              class="pink lighten-1 badge-status"
            >
              จัดส่งแล้ว
            </div>
            <div
              v-if="item.status == 'completed'"
              class="green lighten-1 badge-status"
            >
              เรียบร้อยแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <el-button type="text" size="small" @click="openItem(item)"
            >ดูรายละเอียด</el-button
          >
        </template>

        <template v-slot:item.created_at="{ item }">
          <div>{{ item.created_at | moment("DD/MM/YYYY HH:mm") }}</div>
        </template>
        <template v-slot:item.datetime_received="{ item }">
          <!-- เวลาส่งสินค้า -->
          <div style="width: 150px">
            <div v-bind:class="{ 'red--text': item.delay }">
              {{ item.datetime_received | moment("DD/MM/YYYY") }}
            </div>
            <div v-if="item.cluster_id != null">
              <el-tag
                v-if="
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                "
                size="mini"
                type="info"
                >รอบส่ง
                {{
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                    .delivery
                }}</el-tag
              >
            </div>
          </div>
        </template>

        <template v-slot:item.user_ref_json="{ item }">
          <!-- ข้อมูลลูกค้า -->
          <div style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.user_address="{ item }">
          <div style="width: 220px; padding: 10px 0">
            <p class="progress__title">
              <span v-if="item.user_address != null">{{
                item.user_address.label
              }}</span>
              <template v-if="item.user_address">
                <span v-if="item.user_address.place_detail != null">
                  {{ item.user_address.place_detail.address }}
                  {{ item.user_address.place_detail.sub_district }}
                  {{ item.user_address.place_detail.district }}
                  <strong>{{ item.user_address.place_detail.postcode }}</strong>
                </span>
              </template>
            </p>
          </div>
        </template>

        <template v-slot:item.postalcode="{ item }">
          <div style="width: 100px; padding: 10px 0">
            {{ item.postalcode }}
          </div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div>
            <strong>฿ {{ item.amount.total | numFormat("0,0.00") }}</strong>
            <br />

            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'transfer'"
            >
              โอนเงิน
              <i
                v-if="item.payment.payment_image_url != null"
                @click="viewSlip(item.payment.payment_image_url)"
                class="far fa-file-image"
              ></i>
            </span>
            <span class="font-xs grey--text" v-if="item.payment_type == 'cash'"
              >ชำระเงินสด</span
            >
            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'creditcard'"
              >บัตรเครดิต</span
            >
            <span class="font-xs grey--text" v-if="item.payment_type == 'qr'"
              >พร้อมเพย์</span
            >
          </div>
        </template>
      </v-data-table>

      <!-- <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div> -->
    </el-card>
  </v-container>
</template>

<script>
import Service from "@/services";
import moment from "moment";

export default {
  data() {
    return {
      activeTab: 0,
      mode: "admin",
      pageCount: 0,
      isLoading: false,
      date: "",
      orderList: [],
      resultList: [],
      refresh: null,
      height: "calc(100vh - 290px)",
      amount: {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "order_type",
        },
        { text: "วันที่สั่งซื้อ", value: "created_at", sortable: false },
        {
          text: "วันที่ต้องจัดส่ง",
          value: "datetime_received",
          sortable: false,
        },
        { text: "ข้อมูลลูกค้า", value: "user_ref_json", sortable: false },
        { text: "การจัดส่ง", value: "user_address", sortable: false },
        // { text: "ไปรษณีย์", value: "postcode", sortable: false },
        { text: "จำนวนเงิน", value: "amount", sortable: false },
        { text: "", value: "action", sortable: false },
      ],
      statusOrdering: [
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
      permission: null,
      paymentSlip: null,
      selectedStatus: "pending",
      search: null,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      totalItems: 0,
    };
  },
  watch: {
    options: {
      handler() {
        this.loadOrder();
      },
      deep: true,
    },
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;
      this.loadOrder();
    });

    this.date = moment().format("LLLL");
  },
  methods: {
    loadOrder() {
      this.isLoading = true;
      this.amount = {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        discount: 0,
        completed: 0,
      };

      let params = {
        order_type: "commerce",
        begin: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        status: this.selectedStatus,
        per_page: this.options.itemsPerPage,
        current_page: this.options.page,
      };

      if (this.search != null) {
        params.search = this.search;
      }

      if (
        ["processing", "cooking", "ready-to-go", "delivering"].includes(
          params.status
        )
      ) {
        params.sorting_key = "datetime_received";
        params.sorting_type = "asc";
      }

      this.orderList = [];
      Service.Order.getCommerceOrders(params).then((res) => {
        this.isLoading = false;
        if (res.success) {
          this.totalItems = res.data.total;
          this.orderList = res.data.rows.map((item) => {
            var currentDate = moment();
            let targetDate = moment(item.datetime_received);
            let delay = false;
            let postalcode = "";
            if (item.user_address.place_detail != null) {
              let s = item.user_address.place_detail.address.split(" ");

              if (!isNaN(s[s.length - 1])) {
                postalcode = s[s.length - 1];
              }

              if (item.user_address.place_detail.postcode) {
                postalcode = item.user_address.place_detail.postcode;
              }
            }

            if (targetDate.isBefore(currentDate)) {
              delay = true;
            }
            return { ...item, postalcode: postalcode, delay: delay };
          });

          /*
          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
          */

          this.resultList = this.orderList;
        }
      });
    },
    onNewOrder() {
      if (this.mode == "enterprise_manager") {
        let ent_id = this.permission.user.permission_json
          .included_enterprises[0];
        this.$router.push("/commerce/create/order?ent_id=" + ent_id);
      } else {
        this.$router.push("/commerce/create/order");
      }
    },
    openItem(item) {
      window
        .open("/commerce/view/order/" + item.order_reference, "_blank")
        .focus();
    },
    viewSlip(url) {
      this.paymentSlip = url;
    },
    handleTabChanged(status) {
      this.selectedStatus = status;
      this.loadOrder();
      // if (type == "all") {
      //   this.resultList = this.orderList;
      // } else {
      //   this.resultList = this.orderList.filter((x) => x.status == type);
      // }
    },
    updatePagination(pagination) {
      console.log("update:pagination", pagination);
    },
  },
  beforeRouteLeave(to, from, next) {
    //this.$store.dispatch("Auth/setWorkState", "working");
    //console.log("clearInterval");
    //clearInterval(this.refresh);
    next();
  },
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgb(241, 241, 241);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white;
}

.v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
